import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import {withRouter} from 'react-router';
import propTypes from 'prop-types';
import * as Actions from '../actions';
import lang from '../constants/Languages.js';
import moment from 'moment';

//import components
import LoadingIndicator from '../components/LoadingIndicator.js';
import BackButton from '../components/items/BackButton.js';
import ItemBreadcrumbs from '../components/items/ItemBreadcrumbs.js';
import NewsMenu from '../components/news/NewsMenu.js';
import Error505Page from '../components/Error505Page.js';
import Error404Page from '../components/Error404Page.js';

import withTitle from '../scripts/WithTitle.js';
import menuItems from '../scripts/NewsSubpages.js';

//img
import noNewsImg from '../assets/icons/examples-bg.png';

class NewsItem extends Component {
    componentDidMount() {
        const {match, actions} = this.props;

        actions.getNewsItem(match.params.id);
    };

    componentDidUpdate(prevProps, prevState) {
        const { history, clang } = this.props;

        if (clang !== prevProps.clang) {
            history.push({
                pathname: `/news/all`
            });
        }
    };

    render() {
        const { clang, history, showBackButton, pageData, isLoadingError, isFetching, match, location } = this.props;

        if (!menuItems.map(item => item.name).includes(match.params.type)) {
            return (
                <Error404Page location={location}/>
            );
        }

        if (isFetching) {
            return (
                <article className="news__item">
                    <LoadingIndicator/>
                </article>
            );
        };

        if (isLoadingError) {
            return (
                <article className="news__item">
                    <Error505Page />
                </article>
            );
        };

        if (!pageData) {
            return null;
        }

        const breadcrumbsList = [{label: 'home'}, {label: 'news', link: '/news'}, {label: match.params.type, link: `/news/${match.params.type}`}];

        return (
            <section className="news">
                <ItemBreadcrumbs list={breadcrumbsList} currentPage={pageData.title.rendered}/>
                <div className="news__container">
                    <aside className="news__menu-container">
                        <NewsMenu items={menuItems} />
                    </aside>
                    <div className="news__item-container">
                        <BackButton history={history} showBackButton={showBackButton} />
                        <h2 className="back__title">{lang[clang].news.news}</h2>
                        <article className="news__item">
                            <div className="news__item__tag">{lang[clang].main_page[pageData.categories[0]]}</div>
                            <div className="news__item__info">
                                <div className="news__item__img" style={{backgroundImage: "url(" + (pageData.better_featured_image !== null ? pageData.better_featured_image.source_url : noNewsImg) + ")"}}>
                                    <span className="news__item__circle"></span>
                                </div>
                                <h3 dangerouslySetInnerHTML={{__html: pageData.title.rendered}} className="news__item__title" style={this.verticalOrient}>
                                </h3>
                                <p className="news__item__date">{moment(pageData.date).format('DD/MM/YYYY')}</p>
                                <p className="news__item__desc" dangerouslySetInnerHTML={{__html: pageData.content.rendered}} style={this.verticalOrient}></p>
                            </div>
                        </article>
                        <div className="news__item__bottom"></div>
                    </div>
                </div>
            </section>
        );
    };
};

NewsItem.propTypes = {
    clang: propTypes.string.isRequired,
    actions: propTypes.object.isRequired,
    isFetching: propTypes.bool.isRequired,
    isLoadingError: propTypes.bool.isRequired,
    pageData: propTypes.object,
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
    pageData: state.newsItem.pageData,
    isFetching: state.newsItem.isFetching,
    isLoadingError: state.newsItem.isLoadingError,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});


const enhance = compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withTitle,
);

export default enhance(NewsItem);



// WEBPACK FOOTER //
// ./src/containers/NewsItem.js